import styles from "components/cart/steps/CartSteps.module.scss";
import {useTranslation} from "next-i18next";

const CartSteps = ({ current = 1, options = {} }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.cartSteps}>
        <div className={`${styles.step} ${current > 1 ? styles.done : ""} ${current == 1 ? styles.current : ""}`}>{t("Košík")}</div>
        <div className={`${styles.step} ${current > 2 ? styles.done : ""} ${current == 2 ? styles.current : ""}`}>{t("Kontaktné informácie")}</div>
        <div className={`${styles.step} ${current > 3 ? styles.done : ""} ${current == 3 ? styles.current : ""}`}>{t("Doprava a platba")}</div>
    </div>
  );
};

export default CartSteps;
